import keyMirror from 'helpers/keymirror';

const MAINTENANCE_ACTION_TYPES = keyMirror({
  FETCH_FIAT_DEPOSIT_ASSETS: null,
});

export default MAINTENANCE_ACTION_TYPES;
